<!-- Productivity Trends / compact: trigger-only (hidden when parent renders its own trigger) -->
<button
  *ngIf="!showReportTitle && !compactUiHidden"
  type="button"
  class="pt-date-filter-btn"
  data-filter-btn
  (click)="toggleFilterDropdown()"
  [matTooltip]="compactTriggerTooltip"
  matTooltipShowDelay="200">
  <span *ngIf="!compactHideIcon" class="material-symbols-outlined pt-date-filter-btn-icon">filter_alt</span>
  <span class="pt-date-filter-btn-label">{{ compactButtonCaption || appliedFilterLabel }}</span>
</button>

<!-- Standard: title + filter trigger (Apps & Websites, etc.) -->
<div
  *ngIf="showReportTitle"
  class="flex flex-row items-center gap-2 extra-small:gap-3 sm:gap-3 md:gap-4 lg:gap-6 w-full py-2 extra-small:py-3 sm:py-3 md:py-4 px-2 extra-small:px-3 sm:px-4 md:px-0 lg:px-2.5 justify-between">
  <div
    class="flex flex-col extra-small:flex-row sm:flex-row md:flex-row md:items-center gap-2 extra-small:gap-3 sm:gap-4 md:gap-6">
    <div>
      <h2 class="font-semibold text-base extra-small:text-lg sm:text-lg md:text-xl lg:text-2xl text-gray-900 m-0">
        Apps & Websites</h2>
      <div class="text-xs extra-small:text-sm sm:text-sm md:text-sm text-gray-600">Usage analytics dashboard</div>
    </div>
  </div>

    <!-- Filters and Actions -->
    <!-- Tabs and Filter Container -->
    <div class="flex flex-row items-center gap-2">
        <!-- Date Filter -->
        <div class="relative flex-1 extra-small:flex-none sm:flex-none md:flex-none">

            <button (click)="toggleFilterDropdown()" data-filter-btn [disabled]="_dummyDataService.isDemoDataVisible"
                [title]="_dummyDataService.isDemoDataVisible ? 'Filters are disabled for demo data' : ''"
                class="items-center flex gap-0.5 extra-small:gap-1 sm:gap-1 rounded-md px-2 extra-small:px-3 sm:px-3 py-0.5 extra-small:py-1 sm:py-1 text-xs extra-small:text-sm sm:text-sm font-medium border cursor-pointer border-solid border-[#5459D1] outline-none transition-colors flex-1 extra-small:flex-none sm:flex-none"
                [ngClass]="{
                    '!bg-[#5459D1] text-white hover:bg-[#5459D1]': isAppliedFilter && !_dummyDataService.isDemoDataVisible,
                    'bg-white text-[#5459D1] hover:bg-[#5459D1] hover:text-white': !isAppliedFilter && !_dummyDataService.isDemoDataVisible,
                    'bg-gray-100 !border-gray-300 !text-gray-400 cursor-not-allowed': _dummyDataService.isDemoDataVisible
                }">
                <span
                    class="material-symbols-outlined text-[16px] extra-small:text-[18px] sm:text-[18px] relative top-[1px]">filter_alt</span>
                <span class="hidden md:inline">{{ appliedFilterLabel }}</span>
            </button>

            <!-- <button (click)="openFilterModal()"
                class="flex items-center md:hidden gap-0.5 extra-small:gap-1 sm:gap-1 bg-white rounded-md px-2 extra-small:px-3 sm:px-3 py-0.5 extra-small:py-1 sm:py-1 text-xs extra-small:text-sm sm:text-sm font-medium border cursor-pointer border-solid border-[#5459D1] outline-none text-[#5459D1] hover:bg-[#5459D1] hover:text-white transition-colors flex-1 extra-small:flex-none sm:flex-none"
                [ngClass]="isAppliedFilter ? 'bg-[#5459D1] text-white hover:bg-[#5459D1]' : 'bg-white text-[#5459D1] hover:bg-[#5459D1] hover:text-white'">
                <span
                    class="material-symbols-outlined text-[16px] extra-small:text-[18px] sm:text-[18px] relative top-[1px]">filter_alt</span>
                <span class="hidden md:inline">{{ appliedFilterLabel }}</span>
            </button> -->

            <!-- Custom Dropdown for Filter Presets (with date range) -->
            <!-- <div *ngIf="isFilterDropdownOpen" data-filter-dropdown
                class="custom-shadow absolute right-0 top-full mt-1 bg-white !rounded-xl border border-gray-200 z-50 min-w-[375px] !max-w-[580px] md:max-w-[670px] md:min-w-[400px]">
                <app-filter-dropdown [usersList]="currentUserList" [teamsList]="currentTeamList" [loading]="loading"
                    [type]="typeValue" [selectedDate]="dateRange" [selectedShiftInput]="selectedShift"
                    [selectedEmployeesInput]="selectedEmployees" [selectedTeamInput]="selectedTeam" [shifts]="shifts"
                    (filterChanged)="applyFilter($event)"></app-filter-dropdown>
            </div> -->
        </div>
    </div>
</div>
